import { baseApi } from "../baseApi";
import type {
  ApiResponse,
  PaginationMeta,
  RightsCategory,
  RightsFaqDirectory,
  RightsRecommendation,
  RightsQuestionAnswer,
  RightsResource,
} from "./type";

export const rightsAdvocacyApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getRightsCategories: build.query<ApiResponse<RightsCategory[]>, void>({
      query: () => "/rights-advocacy/categories",
      providesTags: ["RightsCategories"],
    }),
    getRightsResources: build.query<
      ApiResponse<{ items: RightsResource[]; meta: PaginationMeta }>,
      { page?: number; query?: string; categoryId?: string }
    >({
      query: (params) => ({ url: "/rights-advocacy/items", params }),
      providesTags: ["RightsItems"],
    }),
    getRightsFaqDirectories: build.query<
      ApiResponse<{ items: RightsFaqDirectory[] }>,
      void
    >({
      query: () => "/rights-advocacy/faq-directories",
      providesTags: ["RightsItems"],
    }),
    getRightsFaqDirectory: build.query<
      ApiResponse<RightsFaqDirectory>,
      { itemId: string; categoryId?: string; query?: string }
    >({
      query: ({ itemId, ...params }) => ({
        url: `/rights-advocacy/faq-directories/${itemId}`,
        params,
      }),
      providesTags: (_result, _error, { itemId }) => [
        { type: "RightsItems", id: itemId },
      ],
    }),
    getRightsResource: build.query<ApiResponse<RightsResource>, string>({
      query: (id) => `/rights-advocacy/items/${id}`,
      providesTags: (_result, _error, id) => [{ type: "RightsItems", id }],
    }),
    getRightsDocumentAccess: build.mutation<
      ApiResponse<{ url: string; expiresAt: string }>,
      { itemId: string; documentId: string }
    >({
      query: ({ itemId, documentId }) => ({
        url: `/rights-advocacy/items/${itemId}/documents/${documentId}/access`,
        method: "GET",
      }),
    }),
    resolveRightsRecommendation: build.mutation<
      ApiResponse<RightsRecommendation | null>,
      { text: string; source: "notebook"; messageKey: string }
    >({
      query: (body) => ({
        url: "/rights-advocacy/recommendations/resolve",
        method: "POST",
        body,
      }),
    }),
    askRightsQuestion: build.mutation<
      ApiResponse<RightsQuestionAnswer | null>,
      { question: string }
    >({
      query: (body) => ({
        url: "/rights-advocacy/questions/answer",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetRightsCategoriesQuery,
  useGetRightsResourcesQuery,
  useGetRightsFaqDirectoriesQuery,
  useGetRightsFaqDirectoryQuery,
  useGetRightsResourceQuery,
  useGetRightsDocumentAccessMutation,
  useResolveRightsRecommendationMutation,
  useAskRightsQuestionMutation,
} = rightsAdvocacyApi;
